module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/exception-example/exception-example.component.scss
// module id = ./src/app/components/examples/exception-example/exception-example.component.scss
// module chunks = main